

<div class="customer_list">
  <table mat-table [dataSource]="dataSource">
    <form [formGroup]="searchForm">
      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="Company Name" formControlName="companyName"/>  
            </div>
            <h3 mat-sort-header>
                Company Name
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.companyName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="serviceAreas">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input style="visibility: hidden;" type="text" placeholder="Company Address" formControlName="companyAddress"/>  
            </div>
            <h3 mat-sort-header>
                Service Areas
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.serviceArea?.toString() }}
        </td>
      </ng-container>

      <ng-container matColumnDef="companyAddress">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="Company Address" formControlName="companyAddress"/>  
            </div>
            <h3 mat-sort-header>
                Company Address
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.companyAddress }}
        </td>
      </ng-container>
      
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="City"/>  
            </div>
            <h3 mat-sort-header>
                City
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.city }}
        </td>
      </ng-container>
      <ng-container matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="State" formControlName="state"/>  
            </div>
            <h3 mat-sort-header>
              State
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.state }}
        </td>
      </ng-container>
      <ng-container matColumnDef="zipCode">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="Zip Code" formControlName="zip" (keypress)="apiService.allowNumbers($event)" maxlength="5"/>  
            </div>
            <h3 mat-sort-header>
              Zip Code
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.zipCode }}
        </td>
      </ng-container>
    
      <ng-container matColumnDef="companyPhone">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="Company Phone" formControlName="companyPhone" (keypress)="apiService.allowNumbers($event)"/>  
            </div>
            <h3 mat-sort-header>
              Company Phone
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.companyPhone  | mask: '(000) 000-0000'}}
        </td>
      </ng-container>
    
      <ng-container matColumnDef="companyEmail">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="Company Email" formControlName="companyEmail"/>  
            </div>
            <h3 mat-sort-header>
              Company Email
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.companyEmail }}
        </td>
      </ng-container>
    
      <ng-container matColumnDef="workOrderEmailAddress">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="Work Order Email Address" formControlName="workOrderEmailAddress"/>  
            </div>
            <h3 mat-sort-header>
              Work Order Email Address
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.workOrderEmailAddress }}
        </td>
      </ng-container>
    
      <ng-container matColumnDef="workOrderPhoneNumber">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="Work Order Phone Number" formControlName="workOrderPhoneNumber" (keypress)="apiService.allowNumbers($event)"/>  
            </div>
            <h3 mat-sort-header>
              Work Order Phone Number
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.workOrderPhoneNumber  | mask: '(000) 000-0000' }}
        </td>
      </ng-container>
    
      <ng-container matColumnDef="companyLicense">
        <th mat-header-cell *matHeaderCellDef >
            <div class="field_sec">
                <input type="text" placeholder="Company License" formControlName="companyLicense"/>  
            </div>
            <h3 mat-sort-header>
              Company License
            </h3>
            
        </th>
        <td *matCellDef="let row" mat-cell>
          {{ row?.companyLicense }}
        </td>
      </ng-container>
    
    
    
      <!-- actions Column -->
       
      <ng-container matColumnDef="actions" stickyEnd>
        <th *matHeaderCellDef class="actions-cell" mat-header-cell>
          <div class="field_sec">
              <div class="search" (click)="searchData()">
                  <mat-icon>search</mat-icon>
              </div>
          </div>
          <h3>
              Actions
          </h3>
    
      </th>
        <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
          <button class="assign_btn" type="button" [matMenuTriggerFor]="actionsMenu" (click)="handlePayment(row)"
            mat-stroked-button>
            Edit Company
          </button>
    
    
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    
      <!-- <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: visibleColumns | paginate: { id: 'server'+pageType, itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalCount };"
            class="clickable route-animations-elements" mat-row>
        </tr> -->
    </form>
    </table>
    <div
      *ngIf="dataSource?.length === 0"
      style="padding: 10px 0; text-align: center"
    >
      No data found.
</div>
</div>

